import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { INFRA_MAP_API, INFRA_MAP_STORE, INFRA_MAP_STORE_LIST } from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: INFRA_MAP_API,
    useProxy: true,
  });

const infraMapSlice = createDatasetSlice({
  api,
  storeName: INFRA_MAP_STORE,
  actionName: INFRA_MAP_STORE_LIST,
  responseMapping: ResponseMapping.Default,
});

export default infraMapSlice;
